var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "totals" }, [
    _c(
      "div",
      { staticClass: "totals-content" },
      [
        (_vm.isCounting || !_vm.subcorpus) && !_vm.error
          ? _c("Spinner", {
              staticStyle: { "margin-right": "0.25em" },
              attrs: { size: "25" },
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "totals-text",
            attrs: { title: _vm.percentOfSearchSpaceClarification },
          },
          [
            _c("div", { staticClass: "totals-type" }, [
              _c(
                "div",
                [
                  _vm._v(
                    _vm._s(_vm.$t("results.resultsTotals.total")) +
                      " " +
                      _vm._s(_vm.resultType)
                  ),
                  !_vm.isFinished
                    ? [
                        _vm._v(
                          " " + _vm._s(_vm.$t("results.resultsTotals.soFar"))
                        ),
                      ]
                    : _vm._e(),
                  _vm._v(":"),
                ],
                2
              ),
              _vm._v(" "),
              _vm.isGroups
                ? _c(
                    "div",
                    [
                      _vm._v(
                        _vm._s(_vm.$t("results.resultsTotals.totalGroups"))
                      ),
                      !_vm.isFinished
                        ? [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("results.resultsTotals.soFar"))
                            ),
                          ]
                        : _vm._e(),
                      _vm._v(":"),
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("div", [
                _vm._v(
                  _vm._s(_vm.$t("results.resultsTotals.searchTime")) + ":"
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "totals-count" }, [
              _c("div", [
                _vm._v(
                  _vm._s(_vm.numPrefix) +
                    _vm._s(_vm.numResults.toLocaleString()) +
                    _vm._s(_vm.numSuffix)
                ),
              ]),
              _vm._v(" "),
              _vm.isGroups
                ? _c("div", [
                    _vm._v(
                      _vm._s(_vm.numPrefix) +
                        _vm._s(_vm.numGroups.toLocaleString()) +
                        _vm._s(_vm.numSuffix)
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", [_vm._v(_vm._s(_vm.searchTime))]),
            ]),
            _vm._v(" "),
            _c(
              "span",
              { staticClass: "totals-percentage" },
              [
                _vm.searchSpaceCount >
                0 /* might also be -1, in this case don't render -- see corpus store documentCount property */
                  ? [
                      _vm._v(
                        "\n\t\t\t\t(" +
                          _vm._s(
                            _vm.frac2Percent(
                              _vm.numResults / _vm.searchSpaceCount
                            )
                          ) +
                          ")\n\t\t\t\t"
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ]
        ),
      ],
      1
    ),
    _vm._v(" "),
    _vm.error
      ? _c(
          "div",
          {
            staticClass: "totals-message text-danger",
            attrs: { title: _vm.error.message },
            on: { click: _vm.continueCounting },
          },
          [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _vm._v(
              " " + _vm._s(_vm.$t("results.resultsTotals.networkError")) + "! "
            ),
            _c(
              "button",
              {
                staticClass: "totals-button",
                attrs: { type: "button" },
                on: { click: _vm.continueCounting },
              },
              [
                _c("span", { staticClass: "fa fa-rotate-right text-danger" }),
                _vm._v(" " + _vm._s(_vm.$t("results.resultsTotals.retry"))),
              ]
            ),
          ]
        )
      : _vm.isLimited
      ? _c(
          "div",
          {
            staticClass: "totals-message text-danger",
            attrs: {
              title: `You may view up to ${_vm.numResultsRetrieved.toLocaleString()}. Additionally, BlackLab stopped counting after ${_vm.numResults.toLocaleString()}.`,
            },
          },
          [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _vm._v(" "),
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("results.resultsTotals.queryLimited")) + ";"
              ),
            ]),
            _vm._v(
              " stopped after " +
                _vm._s(_vm.numResultsRetrieved.toLocaleString()) +
                " from a total of more than " +
                _vm._s(_vm.numResults.toLocaleString()) +
                "\n\t"
            ),
          ]
        )
      : _vm.isFinished && _vm.numResults > _vm.numResultsRetrieved
      ? _c(
          "div",
          {
            staticClass: "totals-message text-danger",
            attrs: {
              title: `You may only view up to ${_vm.numResultsRetrieved.toLocaleString()} results`,
            },
          },
          [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _vm._v(" "),
            _c("b", [
              _vm._v(
                _vm._s(_vm.$t("results.resultsTotals.queryLimited")) + ";"
              ),
            ]),
            _vm._v(
              " stopped after " +
                _vm._s(_vm.numResultsRetrieved.toLocaleString()) +
                " from a total of " +
                _vm._s(_vm.numResults.toLocaleString()) +
                "\n\t"
            ),
          ]
        )
      : _vm.isPaused
      ? _c("div", { staticClass: "totals-message text-info" }, [
          _vm._v(
            "\n\t\t" +
              _vm._s(_vm.$t("results.resultsTotals.heavyQuery")) +
              " - search paused "
          ),
          _c(
            "button",
            {
              staticClass: "totals-button",
              attrs: { type: "button" },
              on: { click: _vm.continueCounting },
            },
            [
              _c("span", { staticClass: "fa fa-rotate-right text-info" }),
              _vm._v(
                " " + _vm._s(_vm.$t("results.resultsTotals.continue")) + " "
              ),
            ]
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }